import { Routes } from '@angular/router';
import { slugPageResolver } from '@pages/global/resolvers';
import { RoutesPath } from '@shared/constants';

export const APP_ROUTES: Routes = [
  {
    path: RoutesPath.MIDDLE_OFFICE,
    loadComponent: () => import('@pages/middle-office/middle-office.component').then((m) => m.MiddleOfficeComponent),
  },
  {
    path: '**',
    resolve: { pageData: slugPageResolver },
    loadComponent: () => import('@pages/global/global.component').then((m) => m.GlobalComponent),
  },
];
